import React, {Component} from 'react'
import {Col, Row} from 'react-bootstrap'
import HorsePhotos from './HorsePhotos'
import NewHorseDetails from './NewHorseDetails'
import {connect} from 'react-redux'
import {convertYearToJalali} from '../../utils/dateHelper'
import showToastr from '../../utils/showToastr'
import filterErrors from '../../utils/filterErrors'
import {Actions} from 'jumpstate'
import {mapKeys, isArray} from 'lodash'
import './Layout/NewHorse.css'

class NewHorseScreen extends Component {
  constructor (props) {
    super(props)
    this.submit = this.submit.bind(this)
    const noop = () => {}
    this.state = {
      message: { status: '', context: '' },
      showForm: true,
      horse: {
        name: '',
        name_fa: '',
        breeder_id: '',
        breeder: '',
        breeder_fa: '',
        color_id: '',
        birth_date: new Date().getFullYear() - 10,
        birth_date_fa: convertYearToJalali(new Date().getFullYear() - 10),
        gender: 'female',
        sire_id: '',
        dam_id: '',
        death_date: undefined,
        death_date_fa: undefined,
        photo_ids: [],
        avatar_id: '',
        avatar_x: '',
        avatar_y: '',
        avatar_w: '',
        avatar_h: '',
        photos: [],
        avatar: this.props.newHorse.avatar,
        avatarSaver: noop
      }
    }
    this.avatarSetter = this.avatarSetter.bind(this)
    this.clearForm = this.clearForm.bind(this)
  }

  avatarSetter (avatarSaver) {
    this.setState({avatarSaver})
  }

  componentWillReceiveProps (nextProps) {
    const {newHorse} = nextProps
    this.setState({horse: {...this.state.horse, avatar: newHorse.avatar, errors: newHorse.errors, touched: newHorse.touched}})
  }

  submit () {
    Actions.saveNewHorse().then((res) => {
      this.clearForm()
      this.setState({message: {status: 'success', context: res.data.messages[0]}})
      showToastr('success', 'اسب جدید', res.data.messages[0])
    }).catch((err) => {
      if (!err.response) {
        showToastr('error', 'اسب جدید', err.message)
      }
      let e = err.response.data.errors
      if (!isArray(e)) {
        mapKeys(e, (value, key) => {
          showToastr('error', 'اسب جدید', value[0])
        })
      } else {
        showToastr('error', 'اسب جدید', e[0])
      }
      this.setState(filterErrors(err.response.data.errors))
    })
  }

  clearForm () {
    Actions.clearNewHorse()
    this.setState({showForm: false, message: { status: '', context: '' }}, () => this.setState({showForm: true}))
  }

  render () {
    const {newHorse, auth} = this.props
    const {horse, message, showForm} = this.state
    return (
      <div className="HorseInfo NewHorse">
        <div className="container">
          {message.context && <div className={`alert alert-${message.status}`}>{message.context}</div>}
          {showForm && <Row className="Wraper">
            <NewHorseDetails
              horse={newHorse.details}
              avatar={horse.avatar}
              errors={newHorse.errors}
              touched={newHorse.touched}
              saveHorse={this.submit}
              clearHorse={this.clearForm}
            />
            <Col lg={5} lgOffset={0} md={6} mdOffset={0} sm={10} smOffset={1} xs={12} xsOffset={0}>
              <HorsePhotos photos={newHorse.photos} horse={horse} auth={auth} />
            </Col>
          </Row>}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    newHorse: state.newHorse,
    auth: state.auth
  }
}

export default connect(mapStateToProps)(NewHorseScreen)



// WEBPACK FOOTER //
// ./src/components/NewHorse/NewHorseScreen.js